import moment from "moment";
import { Box, Grid, Typography } from "@mui/material";
import LoadingComponent from "../../../common/components/LoadingComponent";
import { useAvailableDateRange } from "./hooks";
import { useSelectorState, useSelectorValue } from "../common/providers/selectorProvider";
import { useContext, useEffect } from "react";
import { WindowSizeContext } from "../../../common/context/WindowSizeContext";

export default function AsOfDate({ textOnly = false, tableName }) {
    const { data, isLoading } = useAvailableDateRange(tableName)
    const [startDate, setStartDate] = useSelectorState('start_date', null);
    const [endDate, setEndDate] = useSelectorState('end_date', null);
    const days = useSelectorValue('days');
    const windowSize = useContext(WindowSizeContext)

    useEffect(() => {
        if (data?.max && days) {
            const newStart = moment(data.max)
                .subtract(days - 1, 'days')
                .format('YYYY-MM-DD');

            const newEnd = moment(data.max).format('YYYY-MM-DD');

            setStartDate(newStart);
            setEndDate(newEnd);
        }
    }, [data, days, startDate, endDate]);


    const coverageStartDate = data?.max
        ? moment(data.max).subtract(days - 1, 'days').format('MMMM DD, YYYY')
        : '---';

    const coverageEndDate = data?.max
        ? moment(data.max).format('MMMM DD, YYYY')
        : '---';

    if (isLoading) {
        if (textOnly) {
            return "Loading..."
        }
        return <Box md={2} sx={{ marginY: -1, paddingX: 2, display: 'flex', justifyContent: 'end', width: "100%" }} >
            <LoadingComponent />
        </Box>
    }

    const displayText = <>Data as of {moment(data?.max).format('MMMM DD, YYYY')}</>
    if (textOnly) {
        return displayText
    }

    return <Box textAlign="end" width={"100%"} >
        <Typography variant="body1" >
            {displayText}
        </Typography>
        <Grid item xs={12} sm gap={1} sx={{ display: !windowSize.isOnMobile && 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <Typography sx={{ fontWeight: "500" }}> Coverage Data: </Typography>
            <Typography sx={{ textDecoration: "underline" }}>
                {isLoading ? 'Loading...' : `${coverageStartDate} - ${coverageEndDate}`}
            </Typography>
        </Grid>
    </Box>
}